"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentRenderer = ContentRenderer;
exports.componentToString = componentToString;
exports.contentToString = contentToString;
exports.contentToStringWithoutTags = contentToStringWithoutTags;
exports.removeHtmlTags = removeHtmlTags;
exports.removeDiacritics = removeDiacritics;
exports.textToAnchor = textToAnchor;
exports.hasContent = hasContent;
exports.contentHeadlines = contentHeadlines;
exports.contentRelationships = contentRelationships;
exports.excerpt = excerpt;
var react_1 = __importDefault(require("react"));
var image_1 = __importDefault(require("next/image"));
var link_1 = __importDefault(require("next/link"));
var striptags_1 = __importDefault(require("striptags"));
var remove_accents_1 = __importDefault(require("remove-accents"));
var merge_1 = __importDefault(require("lodash/merge"));
var document_renderer_1 = require("@keystone-6/document-renderer");
// By default the DocumentRenderer will render unstyled html elements.
// We're customising how headings are rendered here but you can customise
// any of the renderers that the DocumentRenderer uses.
var customRenderers = {
    // Render heading blocks
    block: {
        heading: function (_a) {
            var _b, _c, _d;
            var level = _a.level, children = _a.children, textAlign = _a.textAlign;
            var Comp = "h".concat(level);
            return (
            // @ts-ignore
            react_1.default.createElement(Comp, { style: { textAlign: textAlign }, id: textToAnchor((_d = (_c = (_b = children === null || children === void 0 ? void 0 : children[0]) === null || _b === void 0 ? void 0 : _b.props) === null || _c === void 0 ? void 0 : _c.node) === null || _d === void 0 ? void 0 : _d.text) }, children));
        },
    },
    // Render inline relationships
    inline: {
        link: function (_a) {
            var href = _a.href, children = _a.children;
            if ((href === null || href === void 0 ? void 0 : href.startsWith('http')) && href.indexOf('bioclinica.ro') !== -1) {
                href = new URL(href).pathname;
            }
            return react_1.default.createElement(link_1.default, { href: href }, children);
        },
        relationship: function (_a) {
            var relationship = _a.relationship, data = _a.data;
            // If there is more than one inline relationship defined on the document
            // field we need to handle each of them separately by checking the `relationship` argument.
            // It is good practice to include this check even if you only have a single inline relationship.
            if (relationship === 'mention') {
                if (data === null || data.data === undefined) {
                    // data can be null if the content writer inserted a mention but didn't select an author to mention.
                    // data.data can be undefined if the logged in user does not have permission to read the linked item
                    // or if the linked item no longer exists.
                    return react_1.default.createElement("span", null, "[unknown author]");
                }
                else {
                    // If the data exists then we render the mention as a link to the author's bio.
                    // We have access to `id` an `name` fields here because we named them in the
                    // `selection` config argument.
                    return react_1.default.createElement(link_1.default, { href: "/author/".concat(data.data.id) }, data.data.name);
                }
            }
            else if (relationship === 'author') {
                if (data === null || data.data === undefined) {
                    return react_1.default.createElement("span", null, "[unknown author]");
                }
                else {
                    return react_1.default.createElement("a", { href: "/author/".concat(data.data.slug) }, data.data.name);
                }
            }
            else if (relationship === 'test') {
                if (data === null || data.data === undefined) {
                    return react_1.default.createElement("span", null, "[unknown test]");
                }
                else {
                    return (react_1.default.createElement(link_1.default, { className: "test-link", href: "/analize/".concat(data.data.category.slug, "/").concat(data.data.slug) }, data.data.name));
                }
            }
            return null;
        },
    },
};
var customComponentBlocks = {
    // eslint-disable-next-line @next/next/no-img-element
    imageUrl: function (props) { return react_1.default.createElement("img", { src: props.src, alt: props.alt }); },
    imageAsset: function (props) {
        var _a, _b;
        var file = (_b = (_a = props.rel) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.file;
        // eslint-disable-next-line @next/next/no-img-element
        return (file === null || file === void 0 ? void 0 : file.image) ? (react_1.default.createElement(image_1.default, { width: file.image_width || 1000, height: file.image_height || 1000, src: file.image, sizes: "(max-width: 640px) 320px, (max-width: 768px) 384px, (max-width: 840px) 420px, (max-width: 1024px) 512px, (max-width: 1280px) 640px, 768px", placeholder: file.placeholder, alt: props.imageAlt || '' })) : null;
    },
    table: function (props) {
        return (react_1.default.createElement("div", { className: "table-wrapper" },
            react_1.default.createElement("table", { className: props.options.tableClass || undefined },
                react_1.default.createElement("tbody", null, props.rows.map(function (row, i) {
                    return (react_1.default.createElement("tr", { key: i }, row.map(function (column) {
                        var _a;
                        var Comp = i === 0 && ((_a = props.options) === null || _a === void 0 ? void 0 : _a.headerRow) ? 'th' : 'td';
                        return react_1.default.createElement(Comp, { key: column.content.key }, column.content);
                    })));
                })))));
    },
};
var serverRenderers = __assign(__assign({}, customRenderers), { inline: {
        relationship: function () {
            return null;
        },
    } });
var serverCustomComponentBlocks = __assign(__assign({}, customComponentBlocks), { 
    // eslint-disable-next-line @next/next/no-img-element
    imageUrl: function (props) { return react_1.default.createElement("img", { src: props.src, alt: props.alt }); }, imageAsset: function (props) {
        var _a, _b, _c;
        var url = (_c = (_b = (_a = props.rel) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.file) === null || _c === void 0 ? void 0 : _c.url;
        // eslint-disable-next-line @next/next/no-img-element
        return url ? react_1.default.createElement("img", { src: url, alt: props.imageAlt }) : null;
    }, blogPosts: function (props) { return null; } });
function ServerContentRenderer(_a) {
    var content = _a.content, _b = _a.excludeHeaders, excludeHeaders = _b === void 0 ? false : _b;
    if (!content.document) {
        return null;
    }
    var document = excludeHeaders ? content.document.filter(function (i) { return i.type !== 'heading'; }) : content.document;
    return (react_1.default.createElement(document_renderer_1.DocumentRenderer, { document: document, renderers: serverRenderers, componentBlocks: serverCustomComponentBlocks }));
}
var fixTestRelationshipsFromContent = function (content) {
    var recursiveParse = function (content) {
        var _a;
        if (!content.children)
            return content;
        var remaining = (_a = content.children) === null || _a === void 0 ? void 0 : _a.filter(function (item) { return item.text !== ''; });
        if (remaining.length === 1 && remaining[0].type === 'relationship' && remaining[0].relationship === 'test') {
            return remaining[0];
        }
        return __assign(__assign({}, content), { children: content.children.map(function (item) { return recursiveParse(item); }) });
    };
    return content.map(function (item) { return recursiveParse(item); });
};
function ContentRenderer(_a) {
    var content = _a.content, renderers = _a.renderers, componentBlocks = _a.componentBlocks;
    if (!content.document) {
        return null;
    }
    var document = fixTestRelationshipsFromContent(content.document);
    return (react_1.default.createElement(document_renderer_1.DocumentRenderer, { document: document, renderers: renderers ? (0, merge_1.default)({}, customRenderers, renderers) : customRenderers, componentBlocks: componentBlocks ? (0, merge_1.default)({}, customComponentBlocks, componentBlocks) : customComponentBlocks }));
}
var ReactDOMServer = null;
function componentToString(component) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!ReactDOMServer) return [3 /*break*/, 2];
                    return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('react-dom/server')); })];
                case 1:
                    ReactDOMServer = (_a.sent()).default;
                    _a.label = 2;
                case 2: return [2 /*return*/, ReactDOMServer.renderToStaticMarkup(component)];
            }
        });
    });
}
function contentToString(content, excludeHeaders) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, componentToString(react_1.default.createElement(ServerContentRenderer, { content: content, excludeHeaders: excludeHeaders }))];
        });
    });
}
function contentToStringWithoutTags(content, excludeHeaders) {
    return __awaiter(this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = removeHtmlTags;
                    return [4 /*yield*/, contentToString(content, excludeHeaders)];
                case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
            }
        });
    });
}
function removeHtmlTags(value) {
    return (0, striptags_1.default)(value.replace(/<(?:br|\/div|\/p|\/h1|\/h2|\/h3|\/h4|\/h5|\/ul|\/ol|\/li)>/g, '\n\n'));
}
function removeDiacritics(str) {
    if (!str)
        return str;
    return (0, remove_accents_1.default)(str);
}
function textToAnchor(str) {
    var _a;
    return (((_a = removeDiacritics(str)) === null || _a === void 0 ? void 0 : _a.toLowerCase().replace(/[ .,]/g, '-').replace(/--/g, '-').replace(/--/g, '-')) || undefined);
}
function hasContent(content) {
    return !(!(content === null || content === void 0 ? void 0 : content.document) ||
        JSON.stringify(content === null || content === void 0 ? void 0 : content.document) === JSON.stringify([{ type: 'paragraph', children: [{ text: '' }] }]));
}
function contentHeadlines(content, level) {
    var _a;
    var headings = (_a = content === null || content === void 0 ? void 0 : content.document) === null || _a === void 0 ? void 0 : _a.filter(function (item) { return item.type === 'heading' && item.level === level; });
    if (!headings || !headings.length)
        return null;
    return headings.map(function (item) { var _a, _b; return (_b = (_a = item.children) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.text; });
}
function contentRelationships(content, type) {
    var recursiveParse = function (content, result) {
        var _a;
        if (content.type === 'relationship' && content.relationship === type) {
            return __spreadArray(__spreadArray([], result, true), [(_a = content.data) === null || _a === void 0 ? void 0 : _a.data], false);
        }
        return (content.children || []).reduce(function (current, item) { return recursiveParse(item, current); }, result);
    };
    return content.reduce(function (current, item) { return recursiveParse(item, current); }, []);
}
function excerpt(content, size) {
    return __awaiter(this, void 0, void 0, function () {
        var text;
        return __generator(this, function (_a) {
            text = removeHtmlTags(content);
            if (size < text.length) {
                text = text.substring(0, size) + '...';
            }
            text = text.replace(/^\s+|\s+$/g, '');
            text = text.replace('\n\n', '<br/><br/>');
            return [2 /*return*/, text];
        });
    });
}
